var path = '/formViewer/component/spacer/spacerPlaceholder.tpl.html';
var html = "<ui-spacer class=\"fieldListComponent spacer\"\n           field-structure=\"fieldStructure\"\n           collapsible=\"::$ctrl.collapsible\"\n           ui-show-field-details-modal></ui-spacer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;